import { makeAutoObservable } from 'mobx'
import type { IResponseCampaignExecution } from 'entities/Campaign'
import { CampaignContact } from './CampaignContact'

export class CampaignExecution {
  contact
  constructor(public origin: IResponseCampaignExecution) {
    this.contact = new CampaignContact(origin.contact)
    makeAutoObservable(this)
  }

  get id() {
    return this.origin.id
  }
  get last_step_id() {
    return this.origin.last_step_id
  }
  get steps_count() {
    return this.origin.steps_count
  }
  get contact_has_replied() {
    return this.origin.contact_has_replied
  }
  get team_id() {
    return this.origin.team_id
  }
  get isDisabled() {
    return this.contact.isDisabled
  }
}
